import { splitArrayToStrings } from "../../../constant/General";
import { getDateTime } from "../../../utility/dateUtils";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LiveBackground from "../../liveBackground/LiveBackground";
import { drawingV2, slotConfs } from "../../../constant/initDrawing";
import Welcome from "../../live2/Welcome";
import LayoutWrapper from "../../live2/mt/LayoutWrapper";
import ContentWrapper from "../../live2/tc/ContentWrapper";
import RanderSlot from "../../live2/kp/RenderSlot";



const Live3Kh = ({ socket }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const isV4 = location.pathname.startsWith("/live-v4/");
    const [result, setResult] = useState(drawingV2);
    const [currentResult, setCurrentResult] = useState(drawingV2);

    useEffect(() => {
        socket.on("kh_result", (payload) => {
            setCurrentResult(payload);
            if (result.results.length === 0 || result.isInited) {
                setResult(payload)
            }
        });

        return () => {
            socket.off("kh_result");
        }
    }, [socket, result]);

    const onStartDraw = (result) => {
        setResult(result)
    }

    if (result.results.length === 0) return <Welcome onStartDraw={onStartDraw} />

    const onAfterReleaseCallback = () => setResult(currentResult);

    return <LiveBackground result={result} variant={isV4 ? "v4" : undefined}
        preserveInnerBackgrounds={isV4} className="d-flex justify-content-center overflow-hidden mt-2 live2-sc">
        <button
            type="button"
            className="welcome-back-button"
            onClick={() => navigate(isV4 ? "/live-v4" : "/live-v3")}
        >
            Back
        </button>
        <div>
            {!isV4 && <div className="d-flex justify-content-center align-items-center mb-3 f-20 text-info">
                <span className="mr-4 fw-bold f-26">
                    KH
                </span> {getDateTime(result?.drawAt)}</div>}
            <LayoutWrapper>
                <ContentWrapper
                    isDef
                    type="kh"
                    shift="day"
                    image={isV4 ? require("../../../assets/images/live4/kh/kh-v4.png") : undefined}
                >
                    <div className="d-flex position-relative" style={{

                    }}>
                        <div style={{

                        }}>
                            <div style={{ height: "650px", width: "100%", position: "relative" }}
                                className="d-flex justify-content-center align-items-center">
                                <div style={{
                                    height: "650px", width: "710px", fontSize: "96px",
                                    marginTop: "55px"
                                }}>
                                    <div
                                        className="w-100 h-100 d-flex flex-column justify-content-center align-content-between">
                                        {result.results.map((_, i) => {
                                            return <div
                                                style={{
                                                    marginBottom: "28px"
                                                }}
                                                className="d-flex align-items-center justify-content-center w-100"
                                                key={i}>
                                                <RanderSlot
                                                    currentResult={currentResult}
                                                    index={i}
                                                    rowIndex={i}
                                                    isNight={true}
                                                    onAfterReleaseCallback={onAfterReleaseCallback}
                                                    config={slotConfs}
                                                />
                                            </div>
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div style={{
                            height: "650px",
                            width: "100%",
                        }} className="d-flex justify-content-center align-items-center">
                            <div style={{ height: "650px", marginLeft: "310px", marginTop: "28px", position: "relative" }} className="">

                                <div className="h-100">
                                    {result.results.map((result, i) => {
                                        const { number } = result;
                                        const show = splitArrayToStrings(number)
                                        return <div
                                            style={{
                                                height: "141px",
                                                color: "#9C0000",
                                                fontSize: "130px",
                                                marginBottom: "23px"
                                            }}
                                            className="d-flex justify-content-center align-items-center" key={i}>
                                            <div className="d-flex justify-content-start align-items-center"
                                                style={{
                                                    width: "168px", height: "108px", marginRight: "55px"
                                                }}>{show[0]}</div>
                                            <div className="d-flex justify-content-start align-items-center"
                                                style={{ width: "224px", height: "108px" }}> {show[1]}</div>
                                        </div>
                                    })}
                                </div>
                            </div>
                        </div>

                    </div>
                </ContentWrapper>
            </LayoutWrapper>
        </div>
    </LiveBackground>
}

export default Live3Kh;
